import { render, staticRenderFns } from "./ShopMallAddAddress.vue?vue&type=template&id=1bcbf070&scoped=true&"
import script from "./ShopMallAddAddress.vue?vue&type=script&lang=js&"
export * from "./ShopMallAddAddress.vue?vue&type=script&lang=js&"
import style0 from "./ShopMallAddAddress.vue?vue&type=style&index=0&id=1bcbf070&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcbf070",
  null
  
)

export default component.exports